import { AccountType } from './accountType';
import { AccreditedStatus } from './accreditedStatus';
import { Address } from './addresses';
import { EntityType } from './entityType';
import { ExternalAccount } from './externalAccount';
import { RegDStatus } from './regDStatus';
import { SuitabilityQuestionnaire } from './suitabilityQuestionnaire';
import { User } from './users';

export type AccountId = number;

export enum ACCOUNT_ERROR {
  NOT_FOUND = 'NotFoundException',
}

export interface Account {
  id: AccountId;
  ncId?: string;
  ncAccountOwnerLinkId?: number;
  primaryUser: User;
  name: string;
  type: AccountType;
  entityType?: EntityType;
  entityName?: string;
  entityTitle?: string;
  address: Address;
  externalAccount?: ExternalAccount;
  suitabilityQuestionnaire?: SuitabilityQuestionnaire;
  phoneNumber: string;
  accreditedStatus: AccreditedStatus;
  createdAtIp: string;
  createdAt: Date;
  updatedAt?: Date;
  active: boolean;
  hasEin?: boolean;
  regDStatus?: RegDStatus;
  rewardsAccountUuid: string | null;
}

/**
 * The shape of an account request made to the API.
 */
export interface AccountCreateRequest {
  primaryUserId: number;
  type: AccountType;
  address: Address;
  accreditedStatus: AccreditedStatus;
  entityType: EntityType | null;
  entityName: string | null;
  entityTitle: string | null;
  suitabilityQuestionnaire: {
    accreditedInvestor: boolean;
    netWorthOver1m: boolean;
    individualIncomeOver200k: boolean;
    jointIncomeOver300k: boolean;
    organizationAssetsOver5m?: boolean;
    investmentNotOver10percentNetWorthOrIncome?: boolean;
    associatedWithFinra: boolean;
    finraInstitutionName?: string;
    associatedWithPublicCompany: boolean;
    publicCompanyTickers?: string;
  };
  ssn: string;
  ein: string | null;
  phoneNumber: string;
}
